import { __assign, __rest } from "tslib";
import React from 'react';
import c from 'classnames';
import ToggleButton from '../../../../ToggleButton';
import s from './ActionBarToggleButton.scss';
/**
 * Provides our `ToggleButton` with some additional ActionBar specific styling.
 */
var ActionBarToggleButton = function (_a) {
    var className = _a.className, activated = _a.activated, children = _a.children, Icon = _a.icon, rest = __rest(_a, ["className", "activated", "children", "icon"]);
    return (React.createElement(ToggleButton, __assign({ className: c(s['root'], className), icon: Icon, activated: activated }, rest)));
};
ActionBarToggleButton.displayName = 'ActionBarToggleButton';
export default ActionBarToggleButton;
//# sourceMappingURL=ActionBarToggleButton.js.map